import React from "react";

import { ImporterView } from "./ImporterView";

export default function ImportQSData() {
  return <ImporterView />;
}
